import { CheckCircleIcon, XCircleIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { type ReactNode } from "react";
import { useTranslations } from "use-intl";

type Props = {
  isIncluded: boolean;
  label: ReactNode;
};

export const RoomFeature = ({ isIncluded, label }: Props) => {
  return (
    <div className="flex gap-1 text-sm">
      <div className="shrink-0">
        {isIncluded ? (
          <CheckCircleIcon
            size={18}
            weight="bold"
            color="var(--color-core-accent-500)"
          />
        ) : (
          <XCircleIcon
            size={18}
            weight="bold"
            color="var(--color-text-disabled-tertiary)"
          />
        )}
      </div>
      <span
        className={clsx({
          "font-medium text-core-rahal-600": isIncluded,
          "text-text-primary": !isIncluded,
        })}
      >
        {label}
      </span>
    </div>
  );
};

export const MealFeature = ({ board }: { board: string }) => {
  const t = useTranslations();

  if (board === "BB") {
    return (
      <RoomFeature
        isIncluded
        label={t("hotels.mealOptions.breakfastIncluded")}
      />
    );
  }

  if (board === "HB") {
    return (
      <RoomFeature
        isIncluded
        label={t("hotels.mealOptions.breakfastAndDinnerIncluded")}
      />
    );
  }

  if (board === "FB") {
    return (
      <RoomFeature
        isIncluded
        label={t("hotels.mealOptions.breakfastLunchAndDinnerIncluded")}
      />
    );
  }
  if (board === "AI") {
    return (
      <RoomFeature isIncluded label={t("hotels.mealOptions.allInclusive")} />
    );
  }

  return (
    <RoomFeature
      isIncluded={false}
      label={t("hotels.mealOptions.breakfastNotIncluded")}
    />
  );
};
